import { createSelector } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import { ECrashState } from '../state/e-crash.state';

export const selectECrashState = (state: AppState) => state.eCrash;

export const selectValidationObject = createSelector(selectECrashState, (state: ECrashState) => state.validationObject);
